const FILE_CATEGORY = {
    OTHER: 'OTHER',
    IDENTITY_CARD: 'IDENTITY_CARD',
    SEPA_DOCUMENT: 'SEPA_DOCUMENT',
    COMMERCIAL_REGISTER_EXTRACT: 'COMMERCIAL_REGISTER_EXTRACT',
    DRIVER_LICENCE: 'DRIVER_LICENCE',
    PAYROLL: 'PAYROLL',
    RENTAL_CONTRACT: 'RENTAL_CONTRACT'
};

const FILE_STATUS = {
    UNCHECKED: 'UNCHECKED',
    CORRECTNESS_CHECKED: 'CORRECTNESS_CHECKED',
    AUTHENTICATION_CHECKED: 'AUTHENTICATION_CHECKED',
    DECLINED: 'DECLINED',
    DELETED: 'DELETED'
}

const FILE_ACCESS = {
    PUBLIC: 'PUBLIC',
    PROTECTED: 'PROTECTED'
}

const REQUIRED_PERSON_FILE_CATEGORY = [FILE_CATEGORY.DRIVER_LICENCE, FILE_CATEGORY.PAYROLL]
const REQUIRED_COMPANY_FILE_CATEGORY = [FILE_CATEGORY.DRIVER_LICENCE, FILE_CATEGORY.COMMERCIAL_REGISTER_EXTRACT]

exports = module.exports = {
    FILE_CATEGORY,
    FILE_STATUS,
    FILE_ACCESS,
    REQUIRED_PERSON_FILE_CATEGORY,
    REQUIRED_COMPANY_FILE_CATEGORY,
}